var React = require('react');

function InputPlus (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"32","height":"32","fill":"url(#linearGradient)","key":0}),React.createElement("rect",{"x":"10","y":"15.5","width":"12","height":"1","fill":"#121212","key":1}),React.createElement("rect",{"x":"15.5","y":"22","width":"12","height":"1","transform":"rotate(-90 15.5 22)","fill":"#121212","key":2}),React.createElement("defs",{"key":3},React.createElement("linearGradient",{"id":"linearGradient","x1":"16","y1":"0","x2":"16","y2":"32","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"offset":"0%","stopColor":"rgb(238, 238, 238)","key":0}),React.createElement("stop",{"offset":"100%","stopColor":"rgb(213, 213, 213)","key":1})]))]);
}

InputPlus.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = InputPlus;

InputPlus.default = InputPlus;
